import { useAnimate } from 'motion/react';
import { useEffect } from 'react';

interface Props {
  onComplete: () => void;
}

export const Div1 = ({ onComplete }: Props) => {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    const enterAnimation = async () => {
      // initial state, instant
      await animate(scope.current, { opacity: 0 }, { duration: 0 });

      // actual animation
      await animate(scope.current, { opacity: 1 }, { duration: 1, ease: 'easeInOut' });

      setTimeout(() => {
        // exit
        void animate(scope.current, { opacity: 0 }, { duration: 1, ease: 'easeInOut' }).then(onComplete);
      }, 2000);
    };

    void enterAnimation();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div ref={scope} className="text-center text-xl md:text-2xl italic max-w-xl flex-col flex justify-center items-center gap-8">
      <span>Enchanté de faire votre&nbsp;connaissance,</span>
      <span>L’Atelier vous a confié une&nbsp;mission qui doit rester confidentielle.</span>
    </div>
  );
};
